module.exports = __webpack_public_path__ + "static/media/eurocucumbers.57bfcd9c.webp";